import {
    PRODUCTS_SUCCESS,
    PRODUCTS_SALE_EDIT,
    PRODUCTS_SELECTS,
    PRODUCTS_SEARCH,
    PRODUCTS_SUCCESS_EDIT,
    PRODUCTS,
    ORDER_SELECT,
    UNSET_PRODUCTOS,
  } from './productos.types';
  import { Action } from '@ngrx/store';
  import { productos } from '../../../../models/productos';
import { ITurnosAsignados } from '../../../../models/turnos-asignados/turnos-asignados.interface';

  export class SetProductsSuccess implements Action {
    readonly type = PRODUCTS_SUCCESS;

    constructor(public producto: productos) {}
  }

  export class UnSetProductsAction implements Action {
    readonly type = UNSET_PRODUCTOS;
}

  export class manipularPedido implements Action {
    readonly type = PRODUCTS;

    constructor(public producto: productos,public turnosAsignados: ITurnosAsignados, public turno: number) {}
  }
    
  export class guardarVenta implements Action {
    readonly type = PRODUCTS;
    constructor(public producto: productos) {}
  }
  
  export class actualizarVenta implements Action {
    readonly type = PRODUCTS_SALE_EDIT;
    constructor( public producto: productos) {} 
  }
  
  export class actualizarProductoSeleccionadoEnLaVenta implements Action {
      readonly type = PRODUCTS_SELECTS;
      constructor( public producto: productos) {} 
  }
  
  export class buscarValorDeUnaVenta implements Action {
    readonly type = PRODUCTS_SEARCH;
    constructor( public producto: productos) {} 
  }
  
  export class actualizarProducto implements Action {
     readonly type = PRODUCTS_SUCCESS_EDIT;
     constructor( public producto: productos) {} 
  }
  
  export class buscarPedido implements Action {
    readonly type = ORDER_SELECT;
    constructor( public producto: productos) {} 
  }

  export type acciones = SetProductsSuccess
                       | manipularPedido
                       | guardarVenta
                       | actualizarVenta
                       | actualizarProductoSeleccionadoEnLaVenta
                       | buscarValorDeUnaVenta
                       | actualizarProducto
                       | buscarPedido
                       | UnSetProductsAction;
  


// WEBPACK FOOTER //
// ./src/pages/meseromesero/state/productos/productos.actions.ts